// extracted by mini-css-extract-plugin
export var buttons = "Navigation-module--buttons--a5dd4";
export var docLinks = "Navigation-module--doc-links--b4814";
export var loginSignupButtons = "Navigation-module--login-signup-buttons--db469";
export var menu = "Navigation-module--menu--ac9c6";
export var navigation = "Navigation-module--navigation--556af";
export var showOnlyOnDesktop = "Navigation-module--showOnlyOnDesktop--9521a";
export var showOnlyOnMobile = "Navigation-module--showOnlyOnMobile--f988c";
export var sideNavLogo = "Navigation-module--side-nav-logo--63dc4";
export var wrapper = "Navigation-module--wrapper--45d9f";